import logo from './logo.svg';

export const settings = {
    "title": "Cimolai CV - Backoffice",
    "apiUrl": "https://api-candidati.cimolai.com/api",
    "ckdPath": "https://api-candidati.cimolai.com/",
    "tinyKey": "u2y9r6cw0e1erg33drzg4fs0swwi1zrs85bcin3ynrsxlwz2",
    "googleMapKey": "AIzaSyBj3nkMvRga0iUEByY_SL-TjxQ54bvwXwE",
    "config": {
        "limit": 100,
        "sortingField": 'id',
        "sortingOrder": 'desc'
    },
    "theme": {
        "siderbarIconColor": 'rgba(233,236,239,.5)'
    },
    "locale": {
        "currency": 'EUR',
        "country": 'it-IT'
    },
    "logo": logo,
    "debug": true,
    "usingCache": false
}